import { Component, OnInit } from '@angular/core';
import { GlobalInfoService } from '@app/core';
import { HistoryUsersInactivationComponent } from './history-inactivation-users/history-users-inactivation.component';
import { HistoryInactivateUserDataService } from './history-inactivation-users/shared/history_inactivate_user-data.services';
import { DatePipe } from '@angular/common';

@Component ({
  selector: 'iw-system-users-inactivation',
  templateUrl: './system-users-inactivation.component.html',
  styleUrls: ['./system-users-inactivation.component.scss'],
  providers: [HistoryUsersInactivationComponent, HistoryInactivateUserDataService, DatePipe]
})
export class SystemUsersInactivationComponent implements OnInit {
  constructor(
    private gis: GlobalInfoService,
    private hic: HistoryUsersInactivationComponent,
  ){ }

  ngOnInit(){
    this.gis.set({ title: 'Inactivación de usuarios' });
  }

  tabClick(data: any){
    if(data.path){
      let tab = data.path[0].innerHTML;
      if(tab == 'Historial de funcionarios inactivos'){
      this.hic.getAllHistoryInactivations();
      }
    }else if(data.target){
      let tab = data.target.textContent;
    
      if(tab == 'Historial de funcionarios inactivos'){
        this.hic.getAllHistoryInactivations();
        }
    }else if(data.srcElement){
      let tab = data.srcElement.innerHTML;
    
      if(tab == 'Historial de funcionarios inactivos'){
        this.hic.getAllHistoryInactivations();
        }
    }
  }
  
}


// WEBPACK FOOTER //
// ./src/app/administration/system-users-inactivation/system-users-inactivation.component.ts